import React from "react";

import {useAuth0} from "@auth0/auth0-react";
import {Avatar, Box, Button, Divider, IconButton, Menu, MenuItem, Typography} from "@mui/material";

const AuthenticationProfile = () => {
    const {
        user,
        isAuthenticated,
        loginWithRedirect,
        logout,
    } = useAuth0();
    const isBeheer = window.location.pathname.startsWith('/beheer');
    const redirectUri = `${window.location.origin}${isBeheer ? '/beheer/login' : '/login'}`;

    const [open, setOpen] = React.useState(false);
    const handleLogin = () => loginWithRedirect();
    const handleLogout = () => logoutWithRedirect();
    const handleToggle = () => setOpen(!open);

    const logoutWithRedirect = () =>
        logout({
            logoutParams: {
                returnTo: redirectUri,
            }
        });

    if (!isAuthenticated) {
        return (
            <Button color="primary" variant="outlined" onClick={handleLogin}>
                Inloggen
            </Button>
        );
    }

    return (
        <Box sx={{ml: 2}}>
            <IconButton onClick={handleToggle} size="small" sx={{p: 0}}>
                <Avatar src={user?.picture} alt={user?.nickname} sx={{width: 32, height: 32}}/>
            </IconButton>

            <Menu
                open={open}
                onClose={handleToggle}
                slotProps={{
                    paper: {
                        elevation: 4,
                        sx: {
                            mt: 5,
                            minWidth: 220,
                            borderRadius: 2,
                        }
                    }
                }}
                anchorOrigin={{ vertical: "top", horizontal: "right"}}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Box px={2} py={1}>
                    <Typography variant="subtitle2">{user?.name || user?.nickname}</Typography>
                </Box>

                <Divider sx={{ my: 1 }} />
                <MenuItem onClick={handleLogout}>Uitloggen</MenuItem>
            </Menu>
        </Box>
    )
}
export default AuthenticationProfile;
